import React, { PropTypes } from 'react';
import { icon } from './../../../../icons/icons';

const Range = (props) => {
    const { widget, actions } = props;

    const onChange = (id, e) => {
        actions.setInputWidgetPlaceholder(id, e.target.value);
    };

    const goBack = () => {
        actions.setWidgetTools('general');
    };

    const multiChange = (e) => {
        actions.setRangeMulti(widget.id, e.target.checked);
    };

    const sMinChange = (e) => {
        if (e.target.value > widget.sMax || e.target.value === '') {
            actions.setRangeScaleMin(widget.id, 0);
        } else {
            actions.setRangeScaleMin(widget.id, parseInt(e.target.value, 10));
        }
    };

    const sMaxChange = (e) => {
        if (e.target.value === '') {
            actions.setRangeScaleMax(widget.id, 100);
        } else {
            actions.setRangeScaleMax(widget.id, parseInt(e.target.value, 10));
        }
    };

    const dMinChange = (e) => {
        if (e.target.value === '') {
            actions.setRangeDefaultMin(widget.id, 0);
        } else {
            actions.setRangeDefaultMin(widget.id, parseInt(e.target.value, 10));
        }
    };

    const dMaxChange = (e) => {
        if (e.target.value === '') {
            actions.setRangeDefaultMax(widget.id, 100);
        } else {
            actions.setRangeDefaultMax(widget.id, parseInt(e.target.value, 10));
        }
    };

    const stepChange = (e) => {
        if (e.target.value === '') {
            actions.setRangeStep(widget.id, 7);
        } else {
            actions.setRangeStep(widget.id, parseInt(e.target.value, 10));
        }
    };

    const singleValueChange = (e) => {
        actions.setRangeSingleValue(widget.id, parseInt(e.target.value, 10));
    };

    return (
        <div className="option">
            <h3 className="option__header">{widget.type} Edit</h3>
            <div className="option__back" onClick={goBack} title="Back">{icon.backArrow()}</div>


            <label htmlFor="">Multi Range</label>
            <input type="checkbox" onChange={multiChange} checked={widget.multi} />
            <br/>
            <br/>
            <label>Range Scale</label>
            <div className="range-scale">
                <div className="range-scale__label">From:</div>
                <input type="number" placeholder="Min" onChange={sMinChange} value={widget.sMin} />
                <div className="range-scale__label">To:</div>
                <input type="number" placeholder="Max" onChange={sMaxChange} value={widget.sMax} />
            </div>

            <br/>
            <br/>

            <label>Default values</label>
            {(widget.multi) ?
                <div className="range-scale">
                    <div className="range-scale__label">From:</div>
                    <input type="number" placeholder="Min" onChange={dMinChange} value={widget.dMin} />
                    <div className="range-scale__label">To:</div>
                    <input type="number" placeholder="Max" onChange={dMaxChange} value={widget.dMax} />
                </div>
                :
                <div className="range-scale">
                    <div className="range-scale__label">Start:</div>
                    <input type="number" placeholder="Min" onChange={singleValueChange} value={widget.singleValue} />
                </div>
            }
            <br/>
            <br/>
            <label>Step:</label>
            <input type="number" placeholder="Min" onChange={stepChange} value={widget.step} />
        </div>
    );
};

Range.propTypes = {
    actions: PropTypes.object.isRequired,
    widget: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        kind: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default Range;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Widgets/Range/Range.jsx